// Listed USD rates checked on 2026-10-17. No credit purchase bonus is included.
// Only verified equivalents are eligible. Preview models are separate models.
// New catalog entries have no verified OpenRouter route. These IDs always use Kie.
export const kieOnlyVideoModelIds = [
    "pixverse/pixverse-v6",
    "vidu/vidu-q4",
    "kwaivgi/kling-v3.0-omni",
    "kwaivgi/kling-v3.0-turbo",
    "google/gemini-omni-1.1-flash",
];
export const kieVideoRates = {
    "pixverse/pixverse-v6": { "720p": 0.036, "1080p": 0.072 },
    "vidu/vidu-q4": { "720p": 0.076, "1080p": 0.096 },
    "kwaivgi/kling-v3.0-omni": { "720p": 0.07, "1080p": 0.09 },
    "kwaivgi/kling-v3.0-turbo": { "720p": 0.09, "1080p": 0.1125 },
    "google/gemini-omni-1.1-flash": { "720p": 0.0525, "1080p": 0.0525 },
    "kwaivgi/kling-v3.0-std": { "720p": 0.07 },
    "bytedance/seedance-2.0-mini": { "720p": 0.041 },
    "bytedance/seedance-2.0": { "720p": 0.205, "1080p": 0.51 },
    "bytedance/seedance-2.0-fast": { "720p": 0.124 },
    "bytedance/seedance-2.5": { "720p": 0.315 },
    // Kie stopped serving Seedance 1.5 Pro on 2026-10-20. Use OpenRouter.
    "alibaba/wan-3.0": { "720p": 0.08, "1080p": 0.16 },
    "alibaba/wan-2.6": { "720p": 0.07, "1080p": 0.105 },
    "alibaba/happyhorse-1.0": { "720p": 0.14, "1080p": 0.24 },
    "alibaba/happyhorse-1.1": { "720p": 0.1125, "1080p": 0.145 },
};
export function selectVideoProvider(modelId, resolution, openRouterRate) {
    if (kieOnlyVideoModelIds.includes(modelId))
        return "kie";
    const kieRate = kieVideoRates[modelId]?.[resolution];
    return kieRate !== undefined && kieRate < openRouterRate ? "kie" : "openrouter";
}
export function selectedVideoRate(modelId, resolution, openRouterRate) {
    return Math.min(openRouterRate, kieVideoRates[modelId]?.[resolution] ?? openRouterRate);
}
